/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCardApprovalsRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {GetCardApprovalsResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const getCardApprovals = (request: GetCardApprovalsRequest, options?: CashRequestOptions) => post<GetCardApprovalsRequest, GetCardApprovalsResponse>("/2.0/cash/get-card-approvals", request, {...options, rejectOnError: true })